import { createPlugin } from "fusion-core";
const sequelize = __NODE__ && require("./db/db");
const schemeFeatureController =
  __NODE__ && require("./controllers/schemeFeatureController");
const schemeDescriptionController =
  __NODE__ && require("./controllers/schemeDescriptionController");
const addonController = __NODE__ && require("./controllers/addons");
const envController = __NODE__ && require("./controllers/env");
const panelMemberController =
  __NODE__ && require("./controllers/PanelMemberController");
const categoryController = __NODE__ && require("./controllers/category");
const userController = __NODE__ && require("./controllers/userController");
__NODE__ && require("dotenv").config();
import { parseRequestBody } from "./utils/bodyparser";
import { CACHE_DURATION } from "../config/config";
const authMiddleware = __NODE__ && require("./middlewares/authMiddleware");
let policyCache = { data: null, timestamp: 0 };
const { ALLOWED_ORIGINS } = require("../config/config");
const router = async (ctx, next) => {
  if (__BROWSER__) {
    return next();
  }
  if (ctx.method === "GET" && ctx.path === "/api/policies/all") {
    await schemeFeatureController.getSchemeFeatureDescriptions(ctx);
    return;
  }
  if (ctx.method === "GET" && ctx.path.startsWith("/api/scheme-description/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await schemeFeatureController.getSchemeFeatureDescriptionsByPk(ctx);
    });
    return;
  }

  if (ctx.method === "GET" && ctx.path === "/api/allAddons") {
    await addonController.getAllAddons(ctx);
    return;
  }

  if (ctx.method === "POST" && ctx.path === "/api/addons") {
    await authMiddleware(ctx, async () => {
      await addonController.createAddon(ctx);
    });
    return;
  }

  if (ctx.method === "GET" && ctx.path === "/api/addons") {
    await authMiddleware(ctx, async () => {
      await addonController.getAllAddons(ctx);
    });
    return;
  }

  if (ctx.method === "GET" && ctx.path.startsWith("/api/addons/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await addonController.getAddonById(ctx);
    });
    return;
  }

  if (ctx.method === "PUT" && ctx.path.startsWith("/api/addons/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await addonController.updateAddon(ctx);
    });
    return;
  }
  if (ctx.method === "DELETE" && ctx.path.startsWith("/api/addons/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await addonController.deleteAddon(ctx);
    });
    return;
  }

  if (ctx.method === "GET" && ctx.path.startsWith("/api/getHpp")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    // await authMiddleware(ctx, async () => {
    await envController.getHPP(ctx);
    // });
    return;
  }

  // Scheme Feature Routes
  if (ctx.method === "GET" && ctx.path === "/api/scheme-features") {
    await authMiddleware(ctx, async () => {
      await schemeFeatureController.getAllSchemeFeatures(ctx);
    });
    return;
  }
  if (ctx.method === "GET" && ctx.path.startsWith("/api/scheme-features/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await schemeFeatureController.getSchemeFeatureById(ctx);
    });
    return;
  }
  if (ctx.method === "POST" && ctx.path === "/api/scheme-features") {
    await authMiddleware(ctx, async () => {
      await schemeFeatureController.createSchemeFeature(ctx);
    });
    return;
  }
  if (ctx.method === "PUT" && ctx.path.startsWith("/api/scheme-features/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await schemeFeatureController.updateSchemeFeature(ctx);
    });
    return;
  }
  if (ctx.method === "DELETE" && ctx.path.startsWith("/api/scheme-features/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await schemeFeatureController.deleteSchemeFeature(ctx);
    });
    return;
  }

  // Scheme Description Routes
  if (ctx.method === "GET" && ctx.path === "/api/descriptions") {
    await authMiddleware(ctx, async () => {
      await schemeDescriptionController.getAllSchemeDescriptions(ctx);
    });
    return;
  }
  if (ctx.method === "GET" && ctx.path.startsWith("/api/descriptions/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await schemeDescriptionController.getSchemeDescriptionById(ctx);
    });
    return;
  }
  if (ctx.method === "POST" && ctx.path === "/api/descriptions") {
    await authMiddleware(ctx, async () => {
      await schemeDescriptionController.createSchemeDescription(ctx);
    });
    return;
  }
  if (ctx.method === "PUT" && ctx.path.startsWith("/api/descriptions/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await schemeDescriptionController.updateSchemeDescription(ctx);
    });
    return;
  }
  if (ctx.method === "DELETE" && ctx.path.startsWith("/api/descriptions/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await schemeDescriptionController.deleteSchemeDescription(ctx);
    });
    return;
  }
  if (
    ctx.method === "DELETE" &&
    ctx.path.startsWith(
      "/api/scheme-features/delete-descriptions/panel-members"
    )
  ) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await schemeFeatureController.deleteSchemeFeature(ctx);
    });
    return;
  }
  // Panel Member Routes
  if (ctx.method === "GET" && ctx.path === "/api/panel-members") {
    await authMiddleware(ctx, async () => {
      await panelMemberController.getAllPanelMembers(ctx);
    });
    return;
  }
  if (ctx.method === "GET" && ctx.path.startsWith("/api/panel-members/")) {
    if (
      ctx.method === "GET" &&
      ctx.path.match(/^\/api\/panel-members\/\d+\/lines$/)
    ) {
      ctx.params = { panelMemberId: ctx.path.split("/")[3] };

      await authMiddleware(ctx, async () => {
        await panelMemberController.getPanelMemberLines(ctx);
      });
      return;
    }

    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await panelMemberController.getPanelMemberById(ctx);
    });
    return;
  }

  if (ctx.method === "POST" && ctx.path === "/api/panel-members") {
    await authMiddleware(ctx, async () => {
      await panelMemberController.createPanelMember(ctx);
    });
    return;
  }
  if (
    ctx.method === "POST" &&
    ctx.path.match(/^\/api\/panel-members\/\d+\/lines$/)
  ) {
    ctx.params = { panelMemberId: ctx.path.split("/")[3] };
    await authMiddleware(ctx, async () => {
      await panelMemberController.createPanelMemberLine(ctx);
    });
    return;
  }
  if (ctx.method === "PUT" && ctx.path.startsWith("/api/panel-members/")) {
    if (
      ctx.method === "PUT" &&
      ctx.path.match(/^\/api\/panel-members\/\d+\/lines\/\d+$/)
    ) {
      const paths = ctx.path.split("/");
      ctx.params = { panelMemberId: paths[3], lineId: paths[5] };
      await authMiddleware(ctx, async () => {
        await panelMemberController.updatePanelMemberLine(ctx);
      });
      return;
    }
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await panelMemberController.updatePanelMember(ctx);
    });
    return;
  }
  if (ctx.method === "DELETE" && ctx.path.startsWith("/api/panel-members/")) {
    if (
      ctx.method === "DELETE" &&
      ctx.path.match(/^\/api\/panel-members\/\d+\/lines\/\d+$/)
    ) {
      const paths = ctx.path.split("/");
      ctx.params = { panelMemberId: paths[3], lineId: paths[5] };
      await authMiddleware(ctx, async () => {
        await panelMemberController.deletePanelMemberLine(ctx);
      });
      return;
    }
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await panelMemberController.deletePanelMember(ctx);
    });
    return;
  }

  // Category Routes
  if (ctx.method === "GET" && ctx.path === "/api/categories") {
    await authMiddleware(ctx, async () => {
      await categoryController.getAllCategories(ctx);
    });
    return;
  }
  if (ctx.method === "GET" && ctx.path.startsWith("/api/categories/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await categoryController.getCategoryById(ctx);
    });
    return;
  }
  if (ctx.method === "POST" && ctx.path === "/api/categories") {
    await authMiddleware(ctx, async () => {
      await categoryController.createCategory(ctx);
    });
    return;
  }
  if (ctx.method === "PUT" && ctx.path.startsWith("/api/categories/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await categoryController.updateCategory(ctx);
    });
    return;
  }
  if (ctx.method === "DELETE" && ctx.path.startsWith("/api/categories/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await categoryController.deleteCategory(ctx);
    });
    return;
  }

  // User Routes

  if (ctx.method === "GET" && ctx.path === "/api/users") {
    await authMiddleware(ctx, async () => {
      await userController.getAllUsers(ctx);
    });
    return;
  }
  if (ctx.method === "GET" && ctx.path.startsWith("/api/users/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await userController.getUserById(ctx);
    });
    return;
  }
  if (ctx.method === "PUT" && ctx.path.startsWith("/api/users/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await userController.updateUser(ctx);
    });
    return;
  }
  if (ctx.method === "DELETE" && ctx.path.startsWith("/api/users/")) {
    ctx.params = { id: ctx.path.split("/").pop() };
    await authMiddleware(ctx, async () => {
      await userController.deleteUser(ctx);
    });
    return;
  }

  return next();
};

export default createPlugin({
  middleware() {
    // sequelize.sync();
    return async (ctx, next) => {
      if (__BROWSER__) {
        return next();
      }

      ctx.request.body = await parseRequestBody(ctx);
      // const origin = ctx.request.headers.host;
      // Handle authentication exceptions first
      if (ctx.method === "POST" && ctx.path === "/api/users/register") {
        await userController.register(ctx);
        return;
      }
      if (ctx.method === "POST" && ctx.path === "/api/users/login") {
        await userController.login(ctx);
        return;
      }

      if (ctx.method === "GET" && ctx.path == "/api/scheme-description") {
        const currentTime = Date.now();
        if (
          policyCache.data &&
          currentTime - policyCache.timestamp < CACHE_DURATION
        ) {
          ctx.body = { uberpolicies: policyCache.data };
        } else {
          try {
            await schemeFeatureController.getSchemeFeatureDescriptions(ctx);
            if (ctx.status === 200) {
              policyCache = {
                data: ctx.body,
                timestamp: currentTime,
              };
            }
            ctx.body = { uberpolicies: ctx.body };
          } catch (error) {
            ctx.body = { error: error.message };
          }
        }
        return;
      }

      await router(ctx, next);
    };
  },
});
